<template>
  <appMajority :is-new="true" />
</template>

<script>
import appMajority from "@/components/catalogs/majorities/Majority";

export default {
  components: {
    appMajority,
  },
};
</script>
